

























import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import { QueryCityPagedList, DeleteCity } from "@/api/pdTeam/index";
import CityDetail from "./detail.vue";

/**
 * 小区管理
 */
@Component({
    components: {
        CityDetail,
    },
})
export default class PdCityManage extends AbpBase {
    data: any[] = [];
    loading: boolean = false;
    tableTotalSize: number = 0;
    showDetail: boolean = false;
    currentCity: any = {};
    queryCondition: any = {
        QueryString: "",
        SkipCount: 1,
        MaxResultCount: 10,
    };

    columns = [
        {
            key: "code",
            title: "编码",
        },
        {
            key: "name",
            title: "名称",
        },
        {
            key: "",
            width: 200,
            title: "操作",
            render: (h: any, p: any) => {
                return h("div", [
                    h(
                        "Button",
                        {
                            props: { type: "primary", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: () => {
                                    this.handleUpdateCity(p.row);
                                },
                            },
                        },
                        "编辑"
                    ),
                    h(
                        "Button",
                        {
                            props: { type: "error", size: "small" },
                            style: { marginRight: "5px" },
                            on: {
                                click: (event: any) => {
                                    this.handleDeleteCity(p.row);
                                },
                            },
                        },
                        "删除"
                    ),
                ]);
            },
        },
    ];

    handleQueryStringInput() {
        this.queryCondition.SkipCount = 1;
        this.getData();
    }

    handleInsertCity() {
        this.currentCity = { id: 0 };
        this.showDetail = true;
    }

    handleUpdateCity(row: any) {
        this.currentCity = row;
        this.showDetail = true;
    }

    handleDeleteCity(row: any) {
        this.$Modal.confirm({
            title: this.L("Tips"),
            content: "确定要删除此小区吗？",
            onOk: async () => {
                await DeleteCity(row.id);
                this.getData();
            },
        });
    }

    handlePageChange(val: any) {
        this.queryCondition.SkipCount = val;
        this.getData();
    }

    handleOk() {
        this.loading = true;
        this.$refs.CityDetail.submit().then((res: any) => {
            if (res) {
                this.showDetail = false;
                this.getData();
            }
            this.loading = false;
        });
    }

    async getData() {
        this.loading = true;
        let res = await QueryCityPagedList(this.queryCondition);
        this.data = res.items;
        this.tableTotalSize = res.totalCount;
        this.loading = false;
    }

    created() {
        this.getData();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/city/index.vue